'use client';
import { Button } from '@prickle/next-ui';
import { useTranslations } from 'next-intl';
import { useFormStatus } from 'react-dom';

export const RegisterButton = ({ isValid }: { isValid: boolean }) => {
  const t = useTranslations('SignUpPage.actions');
  const { pending } = useFormStatus();

  return (
    <Button
      type="submit"
      disabled={pending || !isValid}
      color="primary"
      size="block"
    >
      {pending ? t('registering') : t('register')}
    </Button>
  );
};
